module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av80-74a4f10664883ec0f07767f05b23bc2d.jpg";